import { ref, onUnmounted } from "vue";
import { useQuizWordsStore } from "@/stores/storeQuizWords";

const isShowCountdown = ref(true);
const numberCountdown = ref(3);

let timerCountdown = null;


function createTimer() {
	let timerId = null;
	let store = null;
	const remaining = ref({ hours: "00", minutes: "00", seconds: "00" });

	const start = (totalSeconds) => {
		if (!store) store = useQuizWordsStore();
		if (timerId) {
			clearInterval(timerId);
			timerId = null;
		}
		if (!totalSeconds || totalSeconds <= 0) return;

		let current = totalSeconds;
		const tick = () => {
			const h = Math.floor(current / 3600);
			const m = Math.floor((current % 3600) / 60);
			const s = current % 60;
			remaining.value.hours = String(h).padStart(2, "0");
			remaining.value.minutes = String(m).padStart(2, "0");
			remaining.value.seconds = String(s).padStart(2, "0");
			if (current <= 0) {
				clearInterval(timerId);
				timerId = null;
			} else if (!store.isShowTimeSeries) {
				current--;
			}
		};
		tick();
		timerId = setInterval(tick, 1000);
	};

	const stop = () => {
		clearInterval(timerId);
		timerId = null;
	};

	return { remaining, start, stop };
}

const timerPoints = createTimer();
const timerSeries = createTimer();

export function useGameTimers() {

	let countdownId = null;
	const startCountdown = () => {
		countdownId = setInterval(() => {
			numberCountdown.value--;
			if (numberCountdown.value === 0) {
				clearInterval(countdownId);
				countdownId = null;
				isShowCountdown.value = false;
			}
		}, 1000);
	};

	onUnmounted(() => {
		clearInterval(timerCountdown);
		clearInterval(countdownId);
	});

	return {
		isShowCountdown,
		numberCountdown,
		timerPoints,
		timerSeries,
		startCountdown,
	};
}
